<template>
  <div class="product-compliance-container">
    <div class="row ml-52">
      <div class="compliance-header">
        <!-- <router-link to="/layout/market-place"><span class="compliance-label"><img class="mr-12" src="/static/images/marketplace/marketplace_left_chevron.png" />{{$t('resources')}}</span></router-link> -->
        <router-link to="/layout/market-place"><span class="compliance-label"><img class="mr-12" src="/static/images/marketplace/marketplace_left_chevron.png" /><p>{{$t('resources')}}</p></span></router-link>
        <div class="header-text">
          <p class="header-text-para">{{$t('resourcesHeading')}}<br>{{$t('resourcesHeadingPart2')}}</p>
          <div class="active-class">
            <img src="/static/images/marketplace/compliance_tracker_green_tick.svg" class="breadcrumb-img" />
            <p class="m-0 active">{{$t('Active')}}</p>
          </div>
        </div>
      </div>
      <!-- <router-link class="tools-text sub_heading" to="/layout/market-place"> -->
      <!-- </router-link> -->
      <div class="compliance-tracker-wrapper">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <p class="product-compliance-heading mt-17">{{$t('checkOutFreeResources')}}</p>
          <p class="save-time">{{$t('freeResourcesExploreRapidly')}}</p>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mtb-45-rl-30 mt-5 block-display">
        <div class="col-xs-12 col-sm-12 p-0 col-md-8">
          <div class="row box-min-height ptrb-35 pt-32">
            <div class="col-xs-12 col-sm-12 p-0 text-align pl-40">
              <div class="desc-subheader col-xs-12 col-sm-12 p-0 text-color-blue">
                {{$t('toolsToHelp')}}
              </div>
              <div class="col-xs-12 col-sm-12 p-0 ml--15">
                <p class="m-0 automation">
                  {{$t('toolsToHelpPara1')}}.
                </p>
                <p class="m-0 automation pt-20">
                  {{$t('toolsToHelpPara2')}}.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 p-0 col-md-4 col-lg-4 mr-8 d-flex justify-content-end">
          <img
            class="block-img ml-20 pt-10 free_resources_img1"
            src="/static/images/marketplace/free_resources_img1.svg"
            alt="tracker block"
          />
        </div>
      </div>
      </div>
      <div class="mt--27">
          <hr class="line" />
      </div>

      <div class="row block-display bg-color-blue pl-40 mt-28">
        <div class="col-xs-12 col-sm-12 p-0 col-md-3 col-lg-4 bg-color-blue">
          <img
            class="img-style default-style free_resources_img2"
            src="/static/images/marketplace/free_resources_img2.svg"
            alt="tracker block"
          />
        </div>
        <div class="col-xs-12 col-sm-12 p-0 col-md-8 col-lg-8">
          <div class="row box-min-height bg-color-blue text-color">
            <div class="col-xs-12 col-sm-12 pr-60">
              <div class="desc-subheader-2 col-xs-12 col-sm-12 pt-10">
                {{$t('howToProceedWhenRequirementsNotClear')}}
              </div>
              <div class="col-xs-12 col-sm-12 text-align">
                <ul>
                  <li class="pt-20">{{$t('howToProceedWhenRequirementsNotClearData')}}</li>
                  <li class="pt-20">
                    {{$t('howToProceedWhenRequirementsNotClearDataPara2')}}
                  </li>
                  <!-- <li>
                    {{$t('easyAccessToValuableInsightsli3')}}
                  </li> -->
                </ul>
                <!-- <span
                  >{{$t('easyAccessToValuableInsightspara2')}}</span
                > -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-32">
        <hr class="line" />
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mtb-45-rl-30 block-display">
        <div class="col-xs-12 col-sm-12 p-0 col-md-8">
          <div class="row box-min-height ptrb-35">
            <div class="col-xs-12 col-sm-12 p-0 text-align pl-40 pt-17">
              <div class="desc-subheader col-xs-12 col-sm-12 p-0 text-color-blue">
                {{$t('productComplianceAndTesting')}}
              </div>
              <div class="col-xs-12 col-sm-12 p-0 ml--15">
                <p class="m-0 automation">
                  {{$t('productComplianceAndTestingPara1')}}
                </p>
                <p class="m-0 automation pt-20">
                  {{$t('productComplianceAndTestingPara2')}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 p-0 col-md-4 col-lg-4 mr-8 d-flex justify-content-end">
          <img
            class="block-img ml-20 pt-10 free_resources_img3"
            src="/static/images/marketplace/free_resources_img3.svg"
            alt="tracker block"
          />
        </div>
      </div>
      </div>
      </div>
    </div>
    <MarketPlaceFooter />
  </div>
</template>

<script>
import MarketPlaceFooter from './MarketPlaceFooter.vue';

export default {
  name: 'productCompliance',
  data() {
    return {};
  },
  components: { MarketPlaceFooter },
  methods: {},
  watch: {},
  computed: {},
  mounted() {},
};
</script>

<style scoped>
.compliance-header {
  background: #003357;
  color: white;
  position: relative;
  background-repeat: no-repeat;
  position: relative;
  background-size: 100%;
  height: 200px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding-left: 39px;
}

.header-text {
  display: flex;
  justify-content: space-between;
  margin-right: 60px;
}
.header-text-para {
  padding-left: 40px;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 0px;
}

.active-class {
  display: flex;
  align-items: flex-end;
}
.mr-12{
  margin-right: 12px;
}

.compliance-label {
  font-size: 36px;
  font-weight: 300;
  color: #ffffff;
  display: flex;
}

.breadcrumb-img {
  width: 20px;
  height: 20px;
  margin-right: 16px;
}

.pt-17 {
  padding-top: 17px !important;
}

.pt-32 {
  padding-top: 32px !important;
}

.compliance-label i {
  margin-right: 13px;
}
.compliance-tracker-wrapper {
  background: #ffffff;
  margin-left: 37px;
  margin-right: 37px;
  margin-bottom: 24px;
  border: 1px solid #B3B3B3;
}
.product-compliance-heading {
  font-size: 24px;
  line-height: 34px;
  color: #3E3E3E;
}

.mt-28 {
  margin-top: 28px !important;
}
.pl-40 {
  padding-left: 40px;
}

.ml--15 {
  margin-left: -15px;
}
.pl-40 {
  padding-left: 40px !important;
}

.pr-60 {
  padding-right: 60px;
}

.mt--27 {
  margin-top: -27px;
}
.mt-32 {
  margin-top: 32px;
}
.line {
  border-top: 0.7px solid #D3D3D3;
  margin: 0px 24px;
}
.product-compliance-container {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  overflow-x: hidden;
}

.tools-text {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: normal;
}
.tools-text {
  cursor: pointer;
}
.tools-text > i {
  margin-right: 12px;
}
.sub_heading {
  font-size: 16px;
  color: #2A313A;
}
.text-align {
  text-align: justify;
}
.mt-17 {
  margin-top: 9px;
  margin-left: 16px;
}
.p-20 {
  padding: 30px 20px 0px 10px;
}
/* .ml-50 {
  margin-left: 50px;
} */
.p-0 {
  padding: 0px;
  font-size: 16px;
}
.m-0 {
  margin: 0px;
}
.ptrb-35 {
  padding: 15px 35px 35px 0px;
}
.p-35 {
  padding: 35px;
}
.ptlr-35 {
  padding: 35px 35px 35px 0px;
}
.pb-0 {
  padding-bottom: 0px;
}
.mtb-45-rl-30 {
  margin: 0px 30px 30px 0px;
}
.mtlr-30 {
  margin: 30px 30px 0px 0px;
}
.mr-8 {
  margin-right: 8px;
}
.block-img {
  width: 100%;
  margin-top: 12px;
}
.block-img-pb-0 {
  /* width: 100%; */
  padding-bottom: 0px;
}
.compliance_tracker_img1 {
  width: 312px;
  height: 250px;
}
.compliance_tracker_img2 {
  width: 322px;
  height: 195px;
  margin-left: -20px;
}
.compliance_tracker_img3 {
  width: 312px;
  height: 262px;
}
/* .default-style {
    width: 100%;
    height: 100%;
    flex: 0 0 40%;
} */
/* .img-style {
    width: 100%;
    height: 100%;
} */
.center {
  text-align: center;
}
.text-color-blue {
  color: #0B3C61;
}
.save-time {
  font-size: 16px;
  color: #4D4D4D;
  line-height: 26px;
  margin-bottom: 5px;
  padding-left: 16px;
}
.automation {
  line-height: 26px;
  color: #000000;
  font-size: 16px;
  font-weight: 400;
  text-align: justify;
}
/* .bg-color-blue {
  background: #00518a;
} */
.text-color {
  color: #3E3E3E;
}
.box-min-height {
  height: 100%;
  -webkit-box-flex: 0;
  flex: 0 0 40%;
  margin: 0;
}
.desc-subheader {
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #3E3E3E;
  margin: 0 -16px 14px;
  text-align: initial;
}

.desc-subheader-2 {
  font-weight: 600;
  font-size: 18px;
  line-height: 15px;
  color: #3E3E3E;
  margin: 0 0px 14px;
  text-align: initial;
}
@media (min-width: 1024px) {
  .block-display {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
  .block-display-ht {
    height: 250px;
  }
}
@media (min-width: 1301px) and (max-width: 1399px){
  .pr-60 {
    padding-right: 20px;
    padding-left: 60px;
  }
}

.active {
  position: relative;
  top: 2px;
  font-size: 18px;
}
</style>
